const jobListings = [
    {
        title: "Electrician",
        company: "PowerGrid Services",
        location: "Hyderabad, Telangana",
        salary: "₹3,00,000 - ₹5,00,000 per annum",
        description: "Seeking a skilled Electrician with experience in residential and commercial wiring. Responsibilities include installation, maintenance, and repair of electrical systems.",
        category: "Skilled Workers",
        experience: "3+ years"
    },
    {
        title: "Plumber",
        company: "AquaFix Solutions",
        location: "Chennai, Tamil Nadu",
        salary: "₹2,50,000 - ₹4,00,000 per annum",
        description: "Looking for an experienced Plumber to handle various plumbing tasks, including installation and repair of pipes, fittings, and fixtures.",
        category: "Skilled Workers",
        experience: "2+ years"
    },
    {
        title: "Welder",
        company: "SteelCraft Industries",
        location: "Pune, Maharashtra",
        salary: "₹3,50,000 - ₹5,50,000 per annum",
        description: "Hiring a Welder proficient in MIG and TIG welding techniques. The role involves welding, cutting, and joining metal components.",
        category: "Skilled Workers",
        experience: "4+ years"
    },
    {
        title: "Construction Laborer",
        company: "BuildSmart Constructions",
        location: "Bengaluru, Karnataka",
        salary: "₹1,80,000 - ₹2,50,000 per annum",
        description: "Looking for hardworking Construction Laborers to assist in various construction projects. Tasks include material handling, site cleanup, and assisting skilled workers.",
        category: "Daily Labour",
        experience: "1+ years"
    },
    {
        title: "Forklift Operator",
        company: "WareHouse Logistics",
        location: "Mumbai, Maharashtra",
        salary: "₹2,00,000 - ₹3,00,000 per annum",
        description: "Seeking a certified Forklift Operator to handle the movement and storage of materials within the warehouse. Must have experience with forklift operations and safety protocols.",
        category: "Logistics Workers",
        experience: "2+ years"
    },
    {
        title: "Machine Operator",
        company: "Precision Manufacturing",
        location: "Ahmedabad, Gujarat",
        salary: "₹2,50,000 - ₹4,00,000 per annum",
        description: "Hiring a Machine Operator to oversee the operation of manufacturing machines. Responsibilities include setup, monitoring, and maintenance of equipment.",
        category: "Manufacturing Workers",
        experience: "3+ years"
    },
    {
        title: "Warehouse Worker",
        company: "SupplyChain Solutions",
        location: "Kolkata, West Bengal",
        salary: "₹2,00,000 - ₹3,50,000 per annum",
        description: "Looking for a Warehouse Worker to handle inventory management, packing, and shipping of products. Must have experience in warehouse operations.",
        category: "Logistics Workers",
        experience: "1+ years"
    },
    {
        title: "Carpenter",
        company: "CraftWood Works",
        location: "New Delhi, Delhi",
        salary: "₹3,00,000 - ₹4,50,000 per annum",
        description: "Seeking a skilled Carpenter to construct, install, and repair wooden structures and fixtures. Must be proficient in using hand and power tools.",
        category: "Skilled Workers",
        experience: "3+ years"
    }
];

export default jobListings;
